// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"DrgUaMsBIjvFBCIyxCTSz"};